import { Marinade, MarinadeConfig } from "@marinade.finance/marinade-ts-sdk";
import type { Connection } from "@solana/web3.js";
import { PublicKey } from "@solana/web3.js";
import { MSOL_MINT, NATIVE_SOL, toLamports } from "@stepfinance/common";
import { BN } from "bn.js";
import type { Dispatch, SetStateAction } from "react";

import { confirmOptions } from "../../constants/transaction";
import type { CommonNotificationsStrings } from "../../contexts/language/languageTypes";
import type { ConnectedWallet } from "../../hooks/wallet/useConnectedWallet";
import { STEP_MARINADE_REFERRAL_ACCOUNT } from "../../models/marinade";
import { generateOneToOneNotificationDescription } from "../../utils/notifications";
import { sendTransaction } from "../../utils/transactions";
import { formatStringWithPlaceholders } from "../../utils/utils";

export const marinadeStake = async (
  wallet: ConnectedWallet,
  connection: Connection,
  amount: number,
  onTransactionComplete: Dispatch<SetStateAction<boolean>>,
  mSOLAmount: number,
  notificationStrings: CommonNotificationsStrings,
) => {
  const config = new MarinadeConfig({
    connection: connection,
    publicKey: wallet.publicKey,
    referralCode: new PublicKey(STEP_MARINADE_REFERRAL_ACCOUNT),
  });
  const marinade = new Marinade(config);
  const amountToStake = new BN(toLamports(amount, 9));

  const { transaction } = await marinade.deposit(amountToStake);

  return sendTransaction(
    connection,
    wallet,
    transaction.instructions,
    [],
    true,
    confirmOptions,
    true,
    {
      approveMessage: notificationStrings.approveTransaction,
      inProgress: {
        message: formatStringWithPlaceholders(
          notificationStrings.youAreDoingAction.message,
          notificationStrings.youAreDoingAction.staked,
          "SOL",
        ),
        description: notificationStrings.transactionInProgress,
      },
      success: {
        message: formatStringWithPlaceholders(
          notificationStrings.youDidAction.message,
          notificationStrings.youDidAction.staked,
          "SOL",
        ),
        description: generateOneToOneNotificationDescription({
          tokenA: {
            action: notificationStrings.tokenBalanceChanges.staked,
            amount,
            mint: NATIVE_SOL,
            type: "decrease",
          },
          tokenB: {
            action: notificationStrings.tokenBalanceChanges.received,
            amount: mSOLAmount,
            mint: MSOL_MINT,
            type: "increase",
          },
        }),
      },
    },
    () => onTransactionComplete(true),
  );
};
